import React from 'react';
import moment from 'moment';
import { gMapKey } from 'core/constants';
import SearchBox from 'react-google-maps/lib/components/places/SearchBox';
import { withScriptjs, withGoogleMap, GoogleMap, Marker, Polyline, Circle } from 'react-google-maps';

const defaultPostion = {
  lat: -34.6037239,
  lng: -58.3821802,
};

const INPUT_STYLE = {
  border: '1px solid transparent',
  width: '240px',
  height: '32px',
  marginTop: '10px',
  padding: '0 12px',
  borderRadius: '1px',
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
  fontSize: '14px',
  outline: 'none',
  textOverflow: 'ellipses',
};

export default class extends React.Component {
  handlePlacesChanged = this.handlePlacesChanged.bind(this);
  handleSearchBoxMounted = this.handleSearchBoxMounted.bind(this);

  handlePlacesChanged() {
    const places = this._searchBox.getPlaces();
    this.props.onPlacesChanged(places);
  }

  handleSearchBoxMounted(searchBox) {
    this._searchBox = searchBox;
  }

  render() {
    const { markerDblClick, markerClick } = this.props;
    const listaUbicaciones = this.props.listaUbicaciones ? this.props.listaUbicaciones : [];
    return (
      <GettingStartedGoogleMap
        reference={(map) => this.props.mapRef && this.props.mapRef(map)}
        onIdle={this.props.onIdle && this.props.onIdle}
        containerElement={this.props.containerElement}
        mapElement={this.props.mapElement}
        onMapClick={this.props.onMapClick ? this.props.onMapClick : () => true}
        onRightClick={this.props.onRightClick ? this.props.onRightClick : () => true}
        marker={this.props.marker}
        markers={listaUbicaciones}
        multipleMarkers={this.props.multipleMarkers || []}
        markerDblClick={markerDblClick ? markerDblClick : () => true}
        markerClick={markerClick ? markerClick : () => true}
        ubicacionParada={this.props.ubicacionParada}
        searchBox={this.props.searchBox && this.props.onPlacesChanged ? this.props.searchBox : false}
        onPlacesChanged={this.handlePlacesChanged}
        onSearchBoxMounted={this.handleSearchBoxMounted}
        trayecto={this.props.trayecto || null}
        zoomChange={this.props.zoomChange ? this.props.zoomChange : () => false}
        loadingElement={<div style={{ height: '-webkit-fill-available' }} />}
        googleMapURL={`https://maps.googleapis.com/maps/api/js?libraries=places,geometry&language=es&key=${gMapKey}`}
        zoomLevel={this.props.zoomLevel || 0}
        paradasRadio={this.props.paradasRadio || 50}
        paradasCercanas={this.props.paradasCercanas || []}
        addParadaClick={this.props.addParadaClick ? this.props.addParadaClick : () => true}
        onBoundsChanged={this.props.onBoundsChanged ? this.props.onBoundsChanged : () => true}
        photosMarkers={this.props.photosMarkers}
      />
    );
  }
}

const GettingStartedGoogleMap = withScriptjs(
  withGoogleMap((props) => {
    let defCenter = null;
    if (props.marker) defCenter = props.marker;
    else defCenter = props.ubicacionParada;
    return (
      <GoogleMap
        ref={(ref) => props.reference && props.reference(ref)}
        onIdle={props.onIdle}
        defaultZoom={14}
        center={defCenter || defaultPostion}
        defaultCenter={defCenter || defaultPostion}
        onClick={props.onMapClick}
        onRightClick={props.onRightClick}
        clickableIcons={false}
        onZoomChanged={props.zoomChange}
        onBoundsChanged={props.onBoundsChanged}
      >
        {props.searchBox && (
          <SearchBox
            ref={props.onSearchBoxMounted}
            defaultBounds={
              new window.google.maps.LatLngBounds(new window.google.maps.LatLng(defaultPostion.lat, defaultPostion.lng), new window.google.maps.LatLng(defaultPostion.lat, defaultPostion.lng))
            }
            controlPosition={window.google.maps.ControlPosition.TOP_LEFT}
            onPlacesChanged={props.onPlacesChanged}
          >
            <input type="text" placeholder="Ingrese direccion" style={INPUT_STYLE} />
          </SearchBox>
        )}
        {props.ubicacionParada && <Marker defaultAnimation={2} position={props.ubicacionParada} />}
        {props.marker && <Marker onDblClick={props.markerDblClick} position={props.marker} defaultAnimation={2} />}
        {props.markers.map((marker, index) => (
          <Marker
            key={index}
            onClick={() => props.markerClick(marker.get('id'))}
            label={moment(marker.get('horario')).format('HH:mm')}
            position={marker.getIn(['_localizacion', 0, 'ubicacion']).toJS()}
            defaultAnimation={2}
          />
        ))}
        {props.paradasCercanas.map(
          (itm, index) =>
            itm &&
            itm.get &&
            itm.get('localizacion') && (
              <Marker
                key={index + 'a'}
                icon={{
                  url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
                  anchor: new window.google.maps.Point(17, 45),
                  scaledSize: new window.google.maps.Size(40, 50),
                }}
                label={props.zoomLevel > 14 ? itm.get('alias') || itm.get('nombre') : null}
                position={itm.get('localizacion').toJS()}
                onClick={() => props.addParadaClick(itm)}
              />
            ),
        )}
        {props.multipleMarkers.map(
          (itm, index) =>
            itm &&
            itm.get &&
            itm.get('localizacion') && (
              <Marker
                key={index}
                label={props.zoomLevel > 12 ? itm.get('alias') || itm.get('nombre') : ''}
                position={itm.get('localizacion').toJS()}
                onClick={() => props.markerClick(itm.get('id'))}
              />
            ),
        )}
        {props.photosMarkers && props.photosMarkers.map((itm, index) => itm && itm.get && itm.get('executeAtLocation') && <Marker key={index} position={itm.get('executeAtLocation').toJS()} />)}
        {props.trayecto && <Polyline path={props.trayecto} onClick={props.onMapClick} />}
      </GoogleMap>
    );
  }),
);



// WEBPACK FOOTER //
// src/modules/general/components/gMaps.js